import request from "@/api";
import type { Output } from "@zhihaoscm/entity";
import type { Pageable } from "@/entity/base/BaseEntity";
import { BaseService } from "@/api/services/baseService";
// import { confirmable } from "@/utils/decorator/confirmable";

export interface BatchSaveParam extends Pageable {
    productId: string;
    productType: number;
    outputItems: {
        id?: string;
        outputDate: string;
        ton: number;
    }[];
}

export class OutputService extends BaseService<Output, unknown, unknown, unknown> {
    /** 批量保存 */
    public async batchSave(params: BatchSaveParam) {
        const { data } = await this.service.post(`${this.path}/batch/save`, params);
        return data;
    }
}
export const outputService = new OutputService("/admin/output", request.service);
